import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from "../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from "primereact/inputtextarea";

import HtlResAboutDtlEdit from "./HtlResAboutDtlEdit";
import CustSendPrp from "./CustSendPrp";
import CustBook from "./CustBook";
import CusTrip from "./CusTrip";
//import HtlSalesPlanOffres from "./HtlSalesPlanOffres";
//import HtlAgnQuota from "./HtlAgnQuota";
//import HtlAgnGuarantee from "./HtlAgnGuarantee";
//import HtlAgnFreeRooms from "./HtlAgnFreeRooms";
//import HtlSalesPlanCalc from "./HtlSalesPlanCalc";
import { Checkbox } from 'primereact/checkbox';
import { Timeline } from 'primereact/timeline';
//import HtlResAboutDltInfo from "./HtlResAboutDltInfo";
import { Tooltip } from 'primereact/tooltip';


import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $leadId: String
    $webLang: String
  ) {
    tbl_customer(
      where: {
        lead_id: { _eq: $leadId }
        web_lang: { _eq: $webLang }
      }
    ) {
      id_seq
      name
      lastname
      mail_adress
      PHONE
      COUNTRY
      DEALER
      RECORDING_SOURCE
      STATUS
      CUS_SEARCH_CITY
      CUS_SEARCH_COUTRY
      REAL_TYPE
      DISARE
      MIN_PRICE
      MAX_PRICE
      CURRENCY
      ADMIN_NOTE
      DEALER_NOTE
      NOTE
      REC_DATE
      ACTIVE
      BED_ROOMS
      ROOMS
      LANG
      GRADE
      PURCACHE_REAL
      created_at
      updated_at
      create_user
      update_user
      lead_id
      web_lang
     
     
    }
  }
`;

const GET_FIRM_MAIN_COOP = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
  ) {
    tbl_firm_main_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_main_name_n
      firm_main_type_n
      int_ID
    }
  }
`;






const GET_RBTYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_RETYPE = gql`
  query MyQuery($rttype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $rttype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_SOURCE = gql`
  query MyQuery($source: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $source },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_CUR = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_CONT_PRC = gql`
  query MyQuery(
    $firmMainCode: String
    $firmSubCode: String 
    $firmMainCodeK: String
    $firmSubCodeK: String
  ) {
    tbl_cont_prn(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        firm_main_code_k: { _eq: $firmMainCodeK },
        firm_sub_code_k: { _eq: $firmSubCodeK },
        active: { _eq: true },
      }
    ) {
      id_seq
      cont_type
      active
      currency
      start_date
      end_date
      cont_desc
    }
  }
`;

const GET_PRICE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_MAIN_FIRM = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
        type: { _eq: $type }
       
      }
    ) {
        code
        name
        type
    }
  }
`;

const GET_SUB_FIRM = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
        type: { _eq: $type }
        
       
      }
    ) {
        code
        name
        type
    }
  }
`;

const GET_MAIN_DPR_M = gql`
  query MyQuery($type: String!, $firmSubCode: String) {
    tbl_user_detail(
      where: {
        user_lang: { _eq: $type },
       
       
      }
    ) {
      user_name
      name
     
    }
  }
`;

const GET_MAIN_DPR_MK = gql`
  query MyQuery(
    $type: String
   )
     {
        tbl_gnl_def(
      where: {
        type: { _eq: $type },
       
       
      }
    ) {
        code
        name
        type
      
    }
  }
`;

const GET_SUB_DPR_K = gql`
  query MyQuery(
    $type: String
   )
     {
        tbl_gnl_def(
      where: {
        type: { _eq: $type },
       
       
      }
    ) {
        code
        name
        type
      
    }
  }
`;

const GET_FIRM_MAIN_COOP_K = gql`
  query GetFilteredFirms(
    $type: String
   
  ) {
    tbl_gnl_def(order_by: { code: asc },
      where: {
        type: { _eq: $type }
      
      }
    ) {
      code
      name
      type
      
    }
  }
`;

const GET_FIRM_SUB_COOP_K = gql`
  query GetFilteredFirms(
    $type: String
   
  ) {
    tbl_gnl_def(order_by: { code: asc },
      where: {
        type: { _eq: $type }
      
      }
    ) {
      code
      name
      type
     
    }
  }
`;

const GET_FIRM_SUB_COOP_K2 = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    
  ) {
    tbl_firm_sub_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_sub_code_n
      firm_sub_name_n
      firm_sub_type_n
      int_ID
    }
  }
`;

const GET_FIRM_SUB_COOP_PROFILE = gql`
  query GetFilteredFirms(
    $ownFirmCode: String
   
   
    
  ) {
    tbl_customer_profile_corp(order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
      
        
        
      }
    ) {
      cust_profile_id
      title
      first_name
      middle_name
      last_name
      birth_date
      nationality
      member_class
      member_club


    }
  }
`;

const GET_SUB_DPR_M = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
        type: { _eq: $type },
       
        
       
      }
    ) {
        code
      name
     type
    }
  }
`;

const GET_ACC_M = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
      
        type: { _eq: $type },
      
       
      }
    ) {
      code
      name
     type
    }
  }
`;


const GET_ACC_S = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
       
        type: { _eq: $type },
        
       
      }
    ) {
      code
      name
      type
      
    
    }
  }
`;





const UPDATE_CONT = gql`
mutation UpdateContract(

  $contIdSeq: Int
  $cusName: String
  $cusLastName: String
  $cusMailAdress: String
  $cusPhone: String
  $cusCountry: String
  
  $souDealer: String
  $souRecSource: String
  $souStatus: String
  $tarCity: String
  $tarCountry: String
  $tarRealType: String
  $tarDisare: String
  $tarMinPrice: Int
  $tarMaxPrice: Int
  $tarCurrency: String
  $tarRoom: Int
  $tarBedRoom: Int
  $souAdminNote: String
  $souDealerNote: String
  $souNote: String
  $souRecDate: date 
  $souActive: String
  $souGrade: String
  $souUpdateUser: String


) {
  update_tbl_customer(
    where: {
    
      id_seq: { _eq: $contIdSeq }
    },
    _set: {
    
       name: $cusName,
       lastname: $cusLastName,
       mail_adress: $cusMailAdress,
       PHONE: $cusPhone,
       COUNTRY: $cusCountry,        
       DEALER: $souDealer,
       RECORDING_SOURCE: $souRecSource,
       STATUS: $souStatus,
       CUS_SEARCH_CITY: $tarCity,
       CUS_SEARCH_COUTRY: $tarCountry,
       REAL_TYPE: $tarRealType,
       DISARE: $tarDisare,
       MIN_PRICE: $tarMinPrice,
       MAX_PRICE: $tarMaxPrice,
       CURRENCY: $tarCurrency,
       ROOMS: $tarRoom,
       BED_ROOMS: $tarBedRoom,
       ADMIN_NOTE: $souAdminNote,
       DEALER_NOTE: $souDealerNote,
       NOTE : $souNote,
       REC_DATE: $souRecDate, 
       ACTIVE: $souActive,
       GRADE: $souGrade,
       update_user: $souUpdateUser

    
    }
  ) {
    affected_rows
  }
}
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_CONT = gql`
mutation InsertContract(
 
    $contIdSeq: Int
    $cusName: String
    $cusLastName: String
    $cusMailAdress: String
    $cusPhone: String
    $cusCountry: String
    
    $souDealer: String
    $souRecSource: String
    $souStatus: String
    $tarCity: String
    $tarCountry: String
    $tarRealType: String
    $tarDisare: String
    $tarMinPrice: Int
    $tarMaxPrice: Int
    $tarCurrency: String
    $tarRoom: Int
    $tarBedRoom: Int
    $souAdminNote: String
    $souDealerNote: String
    $souNote: String
    $souRecDate: date 
    $souActive: String
    $souGrade: String
    $souUpdateUser: String
    $souCreateUser: String
    $leadId: String
    $webLang: String
 
  ) {
    insert_tbl_customer(
      objects: {  
       
       id_seq: $contIdSeq,
       name: $cusName,
       lastname: $cusLastName,
       mail_adress: $cusMailAdress,
       PHONE: $cusPhone,
       COUNTRY: $cusCountry,        
       DEALER: $souDealer,
       RECORDING_SOURCE: $souRecSource,
       STATUS: $souStatus,
       CUS_SEARCH_CITY: $tarCity,
       CUS_SEARCH_COUTRY: $tarCountry,
       REAL_TYPE: $tarRealType,
       DISARE: $tarDisare,
       MIN_PRICE: $tarMinPrice,
       MAX_PRICE: $tarMaxPrice,
       CURRENCY: $tarCurrency,
       ROOMS: $tarRoom,
       BED_ROOMS: $tarBedRoom,
       ADMIN_NOTE: $souAdminNote,
       DEALER_NOTE: $souDealerNote,
       NOTE : $souNote,
       REC_DATE: $souRecDate, 
       ACTIVE: $souActive,
       GRADE: $souGrade,
       update_user: $souUpdateUser,
       create_user: $souCreateUser,
       lead_id: $leadId,
       web_lang: $webLang,

  
      }
    ) {
      affected_rows
    }
  }
`;




const CustDtlEditWeb = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  
  const { varCode4, setVarCode4 } = useContext(ThemeContext);
  const { varCode3, setVarCode3 } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext); // kayit durumu kontrol

  const { varCode5, setVarCode5 } = useContext(ThemeContext); // Name Last Name
  const { varCode6, setVarCode6 } = useContext(ThemeContext); // mail
  const { varCode7, setVarCode7 } = useContext(ThemeContext); // phone
  const { varCode8, setVarCode8 } = useContext(ThemeContext); // country
  const { varCode9, setVarCode9 } = useContext(ThemeContext); // Message
  const { varCode11, setVarCode11 } = useContext(ThemeContext); // Link
  const { varCode12, setVarCode12 } = useContext(ThemeContext); // Lang
  const { users } = useContext(UserContext);
  const { id_seq } = useParams();
  //setVarCode4(id_seq);
  
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };


  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {  leadId: id_seq, webLang: varCode12 },
  });



  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.userDprSub;
  const userName = users.usernames

  const [isDisabled, setIsDisabled] = useState(false);
  

 

 
  const [UpdateContract] = useMutation(UPDATE_CONT);
  const [InsertContract] = useMutation(INSERT_CONT);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 

  const firmData = data && data.tbl_customer ? data.tbl_customer[0] : null;
  console.log(firmData);

  
  

  

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm5, setSearchTerm5] = useState("");
  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0);
  
  
  const [firmSubCodeM, setfirmSubCodeM] = useState(firmData ? firmData.firm_sub_code :"");
  const [firmMainCodeK, setfirmMainCodeK] = useState(firmData ? firmData.firm_main_code_k : "");  
  const [firmSubCodeK, seFirmSubCodeK] = useState(firmData ? firmData.firm_sub_code_k : ""); 

  const [accmMainCodeK, setAccMainCodeK] = useState(firmData ? firmData.acc_main_code_k : "");  
  const [accSubCodeK, setAccSubCodeK] = useState(firmData ? firmData.acc_sub_code_k : ""); 

  const [contIdSeqq, setContIdSeqq] = useState(0);
  
 
  const [contIdSeqK, setContIdSeqK] = useState(firmData ? firmData.id_seq_k: "");
  
  
  
  const [saveArr, setSaveArr] = useState(firmData ? firmData.save_arr: 1);
  const [contStatusK, setContStatusK] = useState(firmData ? firmData.k_status: "");
  const [active, setActive] = useState(firmData ? firmData.active : false);
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.sty_start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.REC_DATE) : new Date());
  const [currency, setCurrency] = useState(firmData ? firmData.currency: "");
  const [market, setMarket] = useState(firmData ? firmData.marketing: "");
  const [contGroup, setContGroup] = useState(firmData ? firmData.cont_group: "");
  
  
  const [dprMainM, setDprMainM] = useState(firmData ? firmData.dpr_main_code: "");
  const [dprSubM, setDprSubM] = useState(firmData ? firmData.dpr_sub_code: "");
  const [dprMainMK, setDprMainMK] = useState(firmData ? firmData.dpr_main_code_k: "");
  const [dprSubMK, setDprSubMK] = useState(firmData ? firmData.dpr_sub_code_k: "");
  const [kFIntId, setKFIntId] = useState(firmData ? firmData.k_int_ID: "");
  

  const [restDate, setResDate] = useState(firmData ? new Date(firmData.rez_date): new Date());
  const [contStatus, setContStatus] = useState(firmData ? firmData.status: "PRPR");
  const [resType, setResType] = useState(firmData ? firmData.rez_type: "INCR");
  const [contType, setContType] = useState(firmData ? firmData.cont_type : "HSP");
  const [sourceType, setSourceType] = useState(firmData ? firmData.source_type : "");
  const [resContId, setResContId] = useState(firmData ? firmData.cont_id : "");
  const [resTopId, setResTopId] = useState(firmData ? firmData.rez_top_id : "");
  const [resProfId, setResProfId] = useState(firmData ? firmData.profile_id : 0);
  const [resGuestName, setResGuestName] = useState(firmData ? firmData.first_name : "");
  const [resGuestLastN, setResGuestLastN] = useState(firmData ? firmData.last_name : "");
  const [resGuestCountry, setResGuestCountry] = useState(firmData ? firmData.nationality : "");
  const [resGuestType, setResGuestType] = useState(firmData ? firmData.member_class : "");

  
  const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.id_seq :"");
  const [cusName, setCusName] = useState(firmData ? firmData.name : varCode5);
  const [cusLastName, setCusLastName] = useState(firmData ? firmData.lastname : "");
  const [cusMailAdress, setCusMailAdress] = useState(firmData ? firmData.mail_adress : varCode6);
  const [cusPhone, setCusPhone] = useState(firmData ? firmData.PHONE : varCode7);
  const [cusCountry, setCusCountry] = useState(firmData ? firmData.COUNTRY : varCode8);
  const [cusLang, setCusLang] = useState(firmData ? firmData.LANG : "");
  const [souDealer, setSouDealer] = useState(firmData ? firmData.DEALER : "");
  const [souRecSource, setSouRecSource] = useState(firmData ? firmData.RECORDING_SOURCE : "WEB");
  const [souStatus, setSouStatus] = useState(firmData ? firmData.STATUS : "TENTATIVE");
  const [tarCity, setTarCity] = useState(firmData ? firmData.CUS_SEARCH_CITY : "");
  const [tarCountry, setTarCountry] = useState(firmData ? firmData.CUS_SEARCH_COUTRY : "");
  const [tarRealType, setTarRealType] = useState(firmData ? firmData.REAL_TYPE : "");
  const [tarDisare, setTarDisare] = useState(firmData ? firmData.DISARE : "");
  const [tarMinPrice, setTarMinPrice] = useState(firmData ? firmData.MIN_PRICE : 0);
  const [tarMaxPrice, setTarMaxPrice] = useState(firmData ? firmData.MAX_PRICE : 0);
  const [tarCurrency, setTarCurrency] = useState(firmData ? firmData.CURRENCY : "");
  const [tarRoom, setTarRoom] = useState(firmData ? firmData.ROOMS : 0);
  const [tarBedRoom, setTarBedRoom] = useState(firmData ? firmData.BED_ROOMS : 0);

  const [souAdminNote, setsouAdminNote] = useState(firmData ? firmData.ADMIN_NOTE : "");
  const [souDealerNote, setsouDealeNote] = useState(firmData ? firmData.DEALER_NOTE : varCode11);
  const [souNote, setsouNote] = useState(firmData ? firmData.NOTE : varCode9);
  const [souRecDate, setSouRecDate] = useState(firmData ? new Date(firmData.REC_DATE) : new Date());
  const [souActive, setSouActive] = useState(firmData ? firmData.ACTIVE : "ACTIVE");
  const [souGrade, setSouGrade] = useState(firmData ? firmData.GRADE : "REGULAR CLIENT");
  const [souCreateDate, setSouCreateDate] = useState(firmData ? new Date(firmData.created_at) : new Date());
  const [souUpdateDate, setSouUpdateDate] = useState(firmData ? new Date(firmData.updated_at) : new Date());
  const [souUpdateUser, setSouUpdateUser] = useState(firmData ? firmData.update_user : "");
  const [souCreateUser, setSouCreateUser] = useState(firmData ? firmData.create_user : "");
  const [leadId2, setleadId2] = useState(firmData ? firmData.lead_id : id_seq);
  const [webLang, setWebLang] = useState(firmData ? firmData.web_lang : varCode12);
  const [leadId3, setleadId3] = useState(firmData ? firmData.lead_id : "");
  

  

  const events = [
    { status: '', date: [startDate].map(date => date.toLocaleDateString('tr-TR')), icon: 'pi pi-shopping-cart', color: '#9C27B0', image: 'game-controller.jpg' },
    { status: '', date: [endDate].map(date => date.toLocaleDateString('tr-TR')), icon: 'pi pi-cog', color: '#673AB7' },
   
];

  
  

 
  

  
  
  const convertDateFormat = (inputDate) => {
    const [year, month, day] = inputDate.split("-");
    return `${month}/${day}/${year}`;
  };
 

  //const [endDate, setEndDate] = useState(firmData ? firmData.end_date: "");
  //const formattedDate = incomingDate.split("-").reverse().join("/");

  

  
  
  
  


  
  
  const close_form = messages[currentLocale].close_form;
  
  const typerec = messages[currentLocale].typerec;
  
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const cont_grp_select_holder = messages[currentLocale].cont_grp_select_holder;
  const sub_code = messages[currentLocale].sub_code;
  const select_a_bed_type = messages[currentLocale].select_a_bed_type;
  
 
  const cont_group_title = messages[currentLocale].cont_group_title;
  
  const managing_hotel = messages[currentLocale].managing_hotel;
  
  const room_class_tab = messages[currentLocale].room_class_tab;
  const cont_type_title = messages[currentLocale].cont_type_title;
  const select_a_agency = messages[currentLocale].select_a_agency;
  
  const cont_grp_code_title = messages[currentLocale].cont_grp_code_title;
  const cont_new_button = messages[currentLocale].cont_new_button;
  const market_code_title = messages[currentLocale].market_code_title;
  const market_title = messages[currentLocale].market_title;
  const select_market_holder = messages[currentLocale].select_market_holder;
  const currency_title = messages[currentLocale].currency_title;
  const currency_code_title = messages[currentLocale].currency_code_title;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const integration_id_title = messages[currentLocale].integration_id_title;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_code = messages[currentLocale].sub_department_code;
  const sub_department_name = messages[currentLocale].sub_department_name;

  

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const select_a_department_holder = messages[currentLocale].select_a_department_holder;

  const position = messages[currentLocale].position;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;
  const cont_rules_tab = messages[currentLocale].cont_rules_tab;
  const cont_season_tab = messages[currentLocale].cont_season_tab;
  const cont_reductions_tab = messages[currentLocale].cont_reductions_tab;
  const cont_guarantee_tab = messages[currentLocale].cont_guarantee_tab;
  const cont_special_con_tab = messages[currentLocale].cont_special_con_tab;
  const cont_offers_tab = messages[currentLocale].cont_offers_tab;
  const cont_pax_calcutate_tab = messages[currentLocale].cont_pax_calcutate_tab;

  const cont_management_title = messages[currentLocale].cont_management_title;
  const sales_office_title = messages[currentLocale].sales_office_title;
  const cont_detail_title = messages[currentLocale].cont_detail_title;




 

  



  


  
 

  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_RBTYPE, {
    variables: { drbtype: "RSTS", lang: currentLocale},
  });

  const { loading: rtLoading, error: rtError, data: rtData } = useQuery(GET_RETYPE, {
    variables: { rttype: "BOOK", lang: currentLocale},
  });

  const { loading: sourceLoading, error: sourceError, data: sourceData } = useQuery(GET_SOURCE, {
    variables: { source: "CUTYP", lang: currentLocale},
  });

  const { loading: curLoading, error: curError, data: curData } = useQuery(GET_CUR, {
    variables: { drbtype: "CUR", lang: currentLocale},
  });

  const { loading: marLoading, error: marError, data: marData } = useQuery(GET_CONT_PRC, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, firmMainCodeK: firmMainCodeK, firmSubCodeK},
  });

  const { loading: firmmLoading, error: firmmError, data: firmmData } = useQuery(GET_MAIN_FIRM, {
    variables: { type: "ACT"},
  });

  const { loading: firmsLoading, error: firmsError, data: firmsData } = useQuery(GET_SUB_FIRM, {
    variables: {  type: "STATUS"},
  });

  const { loading: dprmmLoading, error: dprmmError, data: dprmmData } = useQuery(GET_MAIN_DPR_M, {
    variables: { type: "en"},
  });

  const { loading: dprmmkLoading, error: dprmmkError, data: dprmmkData } = useQuery(GET_MAIN_DPR_MK, {
    variables: { type: "REC_SOURCE"},
  });

  

  const { loading: dprsmLoading, error: dprsmError, data: dprsmData } = useQuery(GET_SUB_DPR_M, {
    variables: { type: "CUR"},
  });

  const { loading: dprsmkLoading, error: dprsmkError, data: dprsmkData } = useQuery(GET_SUB_DPR_K, {
    variables: { type: "GRADE"},
  });

  const { loading: fmckloading, error: fmclerror, data: fmckData } = useQuery(GET_FIRM_MAIN_COOP_K, {
    variables: { type: "TYPE"},
  });

  const { loading: fsckloading, error: fsclerror, data: fsckData } = useQuery(GET_FIRM_SUB_COOP_K, {
    variables: { type: "TAG"},
  });

  const { loading: accmLoading, error: accmError, data: accmmData } = useQuery(GET_ACC_M, {
    variables: {  type: "CITY"},
  });

  const { loading: accsLoading, error: accsError, data: accsData } = useQuery(GET_ACC_S, {
    variables: {  type: "COU"},
  });

  //sub code for serach form table

  const { loading: fsck2loading, error: fsc2lerror, data: fsck2Data } = useQuery(GET_FIRM_SUB_COOP_K2, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType},
  });




  const { loading: fmcloading, error: fmcerror, data: fmcdata } = useQuery(GET_FIRM_MAIN_COOP, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType},
  });


  
  const filteredFirms = fmcdata && fmcdata.tbl_firm_main_coop
  ? fmcdata.tbl_firm_main_coop.filter((firm) =>
      firm.firm_main_name_n.toLowerCase().includes(searchTerm5.toLowerCase())
    )
  : [];

  const filteredSubFirms = fsck2Data && fsck2Data.tbl_firm_sub_coop
  ? fsck2Data.tbl_firm_sub_coop.filter((firm) =>
      firm.firm_sub_name_n.toLowerCase().includes(searchTerm5.toLowerCase())
    )
  : [];

  const { loading: fsck2loading2, error: fsc2lerror2, data: fsck2Data2 } = useQuery(GET_FIRM_SUB_COOP_PROFILE, {
    variables: { ownFirmCode :ownFirmMainCode},
  });


  const getTooltipId = (rowData) => `tooltip-${rowData.cust_profile_id}`;
  const [searchTerm1, searchTerm2] = searchTerm.toLowerCase().split(' ');

  const filteredSubFirms2 = fsck2Data2 && fsck2Data2.tbl_customer_profile_corp
  ? fsck2Data2.tbl_customer_profile_corp.filter((firm) => {
      // İlk arama terimi (isim için)
      const searchFields = ['first_name', 'middle_name', 'last_name'];
      const matchesFirstSearch = searchFields.some(field => 
        firm[field] && firm[field].toLowerCase().includes(searchTerm1)
      );

      // İkinci arama terimi (soyadı için)
      const matchesSecondSearch = searchTerm2 ? 
        (firm.last_name && firm.last_name.toLowerCase().includes(searchTerm2)) : 
        true;

      // İki terim de eşleşiyorsa veya ikinci terim boşsa
      return matchesFirstSearch && matchesSecondSearch;
    })
  : [];

  const handleRowAction = (rowData) => {

    setResGuestName(rowData.first_name);
    setResGuestLastN(rowData.last_name);
    setResGuestCountry(rowData.nationality);
    setResGuestType(rowData.member_class);
   
    setResProfId(rowData.cust_profile_id);  
    setVisible3(false);
  };

  useEffect(() => {
    if (filteredSubFirms2.length === 1) {
      const handleEnterPress = (event) => {
        if (event.key === 'Enter') {
          handleRowAction(filteredSubFirms2[0]);
        }
      };
  
      window.addEventListener('keydown', handleEnterPress);
  
      return () => {
        window.removeEventListener('keydown', handleEnterPress);
      };
    }
  }, [filteredSubFirms2]);

  
  

  const roomClassSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const resTypeSelect = rtData && rtData.tbl_gnl_def
  ? rtData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const sourceTypeSelect = sourceData && sourceData.tbl_gnl_def
  ? sourceData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const currencySelectItems = curData && curData.tbl_gnl_def
  ? curData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];



  const contPriceSelectItems = marData && marData.tbl_cont_prn
  ? marData.tbl_cont_prn.map(item => ({
      label: (
        <div>
          <div>{item.cont_desc}</div>
          <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
  <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
        </div>
      ),
      value: item.id_seq,
    }))
  : [];

  const souActiveItems = firmmData && firmmData.tbl_gnl_def
  ? firmmData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];



  const souStatusItems = firmsData && firmsData.tbl_gnl_def
  ? firmsData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];

  const souDealerItems = dprmmData && dprmmData.tbl_user_detail
  ? dprmmData.tbl_user_detail.map(item => ({
    label: item.user_name,
    value: item.user_name,
    name: item.user_name,
    }))
  : [];

  const souSourceItems = dprmmkData && dprmmkData.tbl_gnl_def
  ? dprmmkData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];

  const souGradeItems = dprsmkData && dprsmkData.tbl_gnl_def
  ? dprsmkData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];



  const tarCurrencyItems = dprsmData && dprsmData.tbl_gnl_def
  ? dprsmData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];

  const tarPropertyTypeItems = fmckData && fmckData.tbl_gnl_def
  ? fmckData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];

  const tarDisareItems = fsckData && fsckData.tbl_gnl_def
  ? fsckData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name,
      
    }))
  : [];


  const tarCitytems = accmmData && accmmData.tbl_gnl_def
  ? accmmData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];



  const tarCountryItems = accsData && accsData.tbl_gnl_def
  ? accsData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);

  

  const handleUpdateIdSeq2 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'CUST', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setContIdSeq(updatedIdSeq); // fonksiyon çağrısı yerine state güncelleniyor
      setContIdSeqq(updatedIdSeq); 
      handleUpdateIdSeq();
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };
  
  const handleUpdateIdSeq = async () => {
    const requiredFields = [ 'cusLastName', 'cusName', 'souDealer' ]; // Required fields
    const customFieldNames = {
      
      cusLastName: "Lastname",
      cusName: "Name",
      souDealer: "Broker"
      
    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'CUST', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setContIdSeq(updatedIdSeq); 
        setContIdSeqq(updatedIdSeq); 
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      const emptyFieldsMessage = `Lütfen şu alanları doldurun: ${emptyFields.join(', ')}`;
      window.alert(emptyFieldsMessage);
    }
  };
  
  const validateForm = (requiredFields, customFieldNames) => {
    for (const field of requiredFields) {
      if (!eval(field)) {
        return false;
      }
    }
    return true;
  };
  
  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
    return emptyFields;
  };
  
  useEffect(() => {
    if (contIdSeq !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
      handleinsert(contIdSeq);  
    }
  }, [contIdSeq]);

 

  useEffect(() => {
    if (firmData) {
      setVarCode4(firmData.id_seq);
     
      setContIdSeq(firmData.id_seq);
      setCusName(firmData.name);
      setCusLastName(firmData.lastname);
      setCusMailAdress(firmData.mail_adress);
      setCusPhone(firmData.PHONE);
      setCusCountry(firmData.COUNTRY);
      setCusLang(firmData.LANG);
      setSouDealer(firmData.DEALER);
      setSouRecSource(firmData.RECORDING_SOURCE);
      setSouStatus(firmData.STATUS);
      setTarCity(firmData.CUS_SEARCH_CITY);
      setTarCountry(firmData.CUS_SEARCH_COUTRY);
      setTarRealType(firmData.REAL_TYPE);
      setTarDisare(firmData.DISARE);
      setTarMinPrice(firmData.MIN_PRICE);
      setTarMaxPrice(firmData.MAX_PRICE);
      setTarCurrency(firmData.CURRENCY);
      setTarRoom(firmData.ROOMS);
      setTarBedRoom(firmData.BED_ROOMS);
      setsouAdminNote(firmData.ADMIN_NOTE);
      setsouDealeNote(firmData.DEALER_NOTE);
      setsouNote(firmData.NOTE);
      setSouRecDate(new Date(firmData.REC_DATE));
      setSouCreateDate(new Date(firmData.created_at));
      setSouUpdateDate(new Date(firmData.updated_at));
      setSouActive(firmData.ACTIVE);
      setSouGrade(firmData.GRADE);
      setSouCreateUser(firmData.create_user);
      setSouUpdateUser(firmData.update_user);
      setleadId2(firmData.lead_id);
      setWebLang(firmData.web_lang);
      setleadId3(firmData.lead_id);

 
    }
  }, [firmData]);

  useEffect(() => {
    if (varCode2 == '2') {
     
      setContIdSeq();
      setCusName("");
      setCusLastName("");
      setCusMailAdress("");
      setCusPhone("");
      setCusCountry("");
      setCusLang("");
      setSouDealer("");
      setSouRecSource("");
      setSouStatus("");
      setTarCity("");
      setTarCountry("");
      setTarRealType("");
      setTarDisare("");
      setTarMinPrice("");
      setTarMaxPrice("");
      setTarCurrency("");
      setTarRoom("");
      setTarBedRoom("");
      setsouAdminNote("");
      setsouDealeNote("");
      setsouNote("");
 
      setSouActive("ACTIVE");
      setSouGrade("");
      setSouCreateUser(userName);
      setSouUpdateUser(userName);
      setVarCode4();

 
    }
  }, [varCode2]);

  useEffect(() => {
    if (ownFirmSubType === 'USR') {
      setSouDealer(users.usernames);
      setIsDisabled(true);
    }
  }, [ownFirmSubType, souDealer]);




  const actionTemplate = (rowData) => {
    const { firm_main_code_n, firm_main_name_n, int_ID } = rowData;
    
    setfirmMainCodeK(firm_main_code_n);
    
    refetch();
    
   
    return (
     
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
    
      
    );
      };

      const handleChange = (setter) => (e) => {
        setter(e.target.value);
    };

    const [activeTabR, setActiveTabR] = useState(0);
    
      const handleTabChangeR = (index) => {
        setActiveTabR(index);
      };
  

  

  const handleUpdateCont = () => {
    const year = souRecDate.getFullYear();
    const month = (souRecDate.getMonth() + 1).toString().padStart(2, '0');
    const day = souRecDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    UpdateContract({
      variables: {   
       
        contIdSeq: contIdSeq,
        cusName: cusName,
        cusLastName: cusLastName,
        cusMailAdress: cusMailAdress,
        cusPhone: cusPhone,
        cusCountry: cusCountry,
        cusLang: cusLang,
        souDealer: souDealer,
        souRecSource: souRecSource,
        souStatus: souStatus,
        tarCity: tarCity,
        tarCountry: tarCountry,
        tarRealType: tarRealType,
        tarDisare: tarDisare,
        tarMinPrice: tarMinPrice,
        tarMaxPrice: tarMaxPrice,
        tarCurrency: tarCurrency,
        tarRoom: tarRoom,
        tarBedRoom: tarBedRoom,
        souAdminNote: souAdminNote,
        souDealerNote: souDealerNote,
        souNote: souNote,
        souRecDate: formattedDate, 
        souActive: souActive,
        souGrade: souGrade,
        souUpdateUser: userName,





        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
        setVarCode8(currency);
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
        console.error("GraphQL Errors:", error.graphQLErrors);
        console.error("Network Error:", error.networkError);
        console.error("Message:", error.message);
      });
  };

  const handleinsert = () => {
    const year = souRecDate.getFullYear();
    const month = (souRecDate.getMonth() + 1).toString().padStart(2, '0');
    const day = souRecDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
       InsertContract({
        variables: {
            contIdSeq: contIdSeq,
            cusName: cusName,
            cusLastName: cusLastName,
            cusMailAdress: cusMailAdress,
            cusPhone: cusPhone,
            cusCountry: cusCountry,
            cusLang: cusLang,
            souDealer: souDealer,
            souRecSource: souRecSource,
            souStatus: souStatus,
            tarCity: tarCity,
            tarCountry: tarCountry,
            tarRealType: tarRealType,
            tarDisare: tarDisare,
            tarMinPrice: tarMinPrice,
            tarMaxPrice: tarMaxPrice,
            tarCurrency: tarCurrency,
            tarRoom: tarRoom,
            tarBedRoom: tarBedRoom,
            souAdminNote: souAdminNote,
            souDealerNote: souDealerNote,
            souNote: souNote,
            souRecDate: formattedDate, 
            souActive: souActive,
            souGrade: souGrade,
            souUpdateUser: userName,
            souCreateUser: userName,
            leadId: id_seq,
            webLang: webLang,
         
        },
      })
        .then(() => {
          window.alert("Contract insert successfully!");
          
          setVarCode4(contIdSeq);
          setVarCode2(1);
         
          fetch();
          
        })
        .catch((error) => {
          console.error("Error insert Contract:", error);
          console.error("GraphQL Errors:", error.graphQLErrors);
          console.error("Network Error:", error.networkError);
          console.error("Error Message:", error.message);
        });
    };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;



const handleClose = () => {
  refetch();


 
  // Sayfadan ayrılmadan önce verileri temizle
  // ...

  // Daha sonra sayfadan çıkış yap
  navigate(-1);
};






const items = [{ label: dashboard ,url: "/", target: '_self'},  { label: "Costumer List" ,url:"/crm/cust/cust-list" }, { label: "Customer Details" }];

return (


    
<div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-2 w-5/6">
        <nav>
          <ul className="flex border-solid rounded-md border-b outline-1">
            {items.map((item, index) => (
              <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
                {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
                {item.url ? (
                  <Link to={item.url}>{item.label}</Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="col-span-1 mr-5 flex justify-end">
     
      <button onClick={handleClose} className="text-violet-900 hover:text-violet-200 font-bold">{close_form}</button>
   
      </div>
     
  
    </div> 

    <div className="card mt-2 min-h-[40em]">

    <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
   <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {'Customer Details'}
            </span>
          }
          className="ml-5 flex"
        >

     <div className="  dark:text-gray-100">

<div className="p-4">
      <div className=" border rounded-md  p-4 bg-white">
      

        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">

          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabS} onTabChange={(e) => handleTabChangeS(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Customer Information"}
            </span>
          }
          className="ml-5 flex"
        >
       
            <div className="grid grid-cols-6 mt-5 gap-4">
           


              <div className="col-span-3">

              <label className="block font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {"Name"}</label>
        <InputText className=" w-full" 
        id="username" value={cusName}
        onChange={(e) => setCusName(e.target.value)}
        />
              </div>
              <div className="col-span-3">
              <label className="block font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {"Last Name"}</label>
        <InputText className=" w-full" 
        id="username" value={cusLastName}
        onChange={(e) => setCusLastName(e.target.value)}
        />
              </div>

              <div className="col-span-2">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Email"}</label>
<InputText className=" w-full"  placeholder="name@mail.com"
id="username" value={cusMailAdress}
onChange={(e) => setCusMailAdress(e.target.value)}
/>
</div>
<div className="col-span-2">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Phone"}</label>
<InputText className=" w-full"  placeholder="+44123 121 235"
id="username" value={cusPhone}
onChange={(e) => setCusPhone(e.target.value)}
/>
</div>

<div className="col-span-2">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Country"}</label>
<InputText className=" w-full" 
id="username" value={cusCountry}
onChange={(e) => setCusCountry(e.target.value)}
/>
</div>

<div className="col-span-6">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Note"}</label>
<InputTextarea className="h-24 w-full" 
id="username" value={souNote}
onChange={(e) => setsouNote(e.target.value)}
/>
</div>

                    
              </div>

              <Divider align="left">
                <div className="col-span-4 inline-flex align-items-center">
                    <i className="pi pi-user mr-2"></i>
                    <b>Customer Request</b>
                </div>
            </Divider>

              <div className="grid mt-3 grid-cols-6 gap-4">
            
   
        <div className="col-span-2">
       
<label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
{"City"}
</label>
<Dropdown
className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir

dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
<path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
</svg>}
value={tarCity}
options={tarCitytems}
onChange={(e) => setTarCity(e.value)}
placeholder={"Select City"}
/>
</div>

<div className="col-span-3 ">
       
       <label htmlFor="roomClassDropdown" className="mr-5 font-medium text-gray-700">
       {"/ Country"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={tarCountry}
       options={tarCountryItems}
       onChange={(e) => setTarCountry(e.value)}
       placeholder={"Select Country"}
       />
       </div>

       <div className="col-span-2">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Tag"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={tarDisare}
       options={tarDisareItems}
       onChange={(e) => setTarDisare(e.value)}
       placeholder={"Select Tag"}
       />
       </div>

       <div className="col-span-3">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Property Type"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={tarRealType}
       options={tarPropertyTypeItems}
       onChange={(e) => setTarRealType(e.value)}
       placeholder={"Select Property Type"}
       />
       </div>

       <div className="col-span-2">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Room"}</label>
<InputText className=" w-full" 
id="username" value={tarRoom}
onChange={(e) => setTarRoom(e.target.value)}
/>
</div>
<div className="col-span-2">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Bedroom"}</label>
<InputText className=" w-full" 
id="username" value={tarBedRoom}
onChange={(e) => setTarBedRoom(e.target.value)}
/>
</div>
         
              </div>
              <div className="col-span-2">
            
            <div className="flex mt-3 space-x-2">
            <div className="col-span-2">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Min Budget"}</label>
<InputText className=" w-full" 
id="username" value={tarMinPrice}
onChange={(e) => setTarMinPrice(e.target.value)}
/>
</div>
     

       <div>    

       <label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Max Budget"}</label>
<InputText className=" w-full" 
id="username" value={tarMaxPrice}
onChange={(e) => setTarMaxPrice(e.target.value)}
/></div> 

<div>    

<div className="col-span-1">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Currency"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       style={{ width: '184px' }} 
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={tarCurrency}
       options={tarCurrencyItems}
       onChange={(e) => setTarCurrency(e.value)}
       placeholder={"Select Currency"}
       />
       </div>
</div> 

       
          
            </div>
          </div>

      </TabPanel>

    
      </TabView>
     
          </div>

          

          

   

      <div className="col-span-1 ml-40">

      <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabR} onTabChange={(e) => handleTabChangeR(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabR === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Sources"}
            </span>
          }
          className="ml-5 flex"
        >
       
        <div className="grid mt-3 grid-cols-2 gap-4">
        <div className="col-span-1">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Grade"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={souGrade}
       options={souGradeItems}
       onChange={(e) => setSouGrade(e.value)}
       placeholder={"Select Grade"}
       />
       </div>

       <div className="col-span-1">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Source"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={souRecSource}
       options={souSourceItems}
       onChange={(e) => setSouRecSource(e.value)}
       placeholder={"Select Source"}
       />
       </div>

           
       <div className="col-span-1">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Broker"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={souDealer}
       options={souDealerItems}
       onChange={(e) => setSouDealer(e.value)}
       placeholder={"Select Dealer"}
       disabled={isDisabled}
       />
       </div>

          <div className="col-span-1">
          <label                
         htmlFor="firmname"> {"Record Date"}</label>
        <Calendar className="h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        
        id="firmname" value={souRecDate} dateFormat="dd/mm/yy"
        onChange={(e) => setSouRecDate(e.target.value)} 
        showIcon
        />
      </div>
          <div className="col-span-1">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Status"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={souStatus}
       options={souStatusItems}
       onChange={(e) => setSouStatus(e.value)}
       placeholder={"Select Status"}
       />
       </div>
       <div className="col-span-1">
       
       <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
       {"Active"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={souActive}
       options={souActiveItems}
       onChange={(e) => setSouActive(e.value)}
       placeholder={"Select Location"}
       />
       </div>

     

          <div className="mt-10 col-span-2">
            
            <div className="flex space-x-2">
   
          
            </div>
            <Divider align="left">
                <div className="col-span-4 inline-flex align-items-center">
                    <i className="pi pi-user mr-2"></i>
                    <b> Notes</b>
                </div>
            </Divider>
          </div>
          <div className="col-span-2">
          <label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Consultant Note"}</label>
<InputTextarea className="h-28 w-full" 
id="username" value={souDealerNote}
onChange={(e) => setsouDealeNote(e.target.value)}
/>
              </div>

              <div className="col-span-2">
              <label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Admin Note"}</label>
<InputTextarea className="h-28 w-full" 
id="username" value={souAdminNote}
onChange={(e) => setsouAdminNote(e.target.value)}
disabled={isDisabled}
/>
              </div>
         
         
        </div>
        

      </TabPanel>

      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabR === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Logs"}
            </span>
          }
          className="ml-5 flex"
        >
     
     <div className="grid mt-3 grid-cols-2 gap-4">
     <div className="col-span-1">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Register User"}</label>
<InputText className=" w-full" 
id="username" value={souCreateUser}
onChange={(e) => setSouCreateUser(e.target.value)}
/>
</div>

              <div className="col-span-1">
            <label className="block font-bold mb-1">Register Date</label>
            <Calendar className="w-full h-11" 
              id="firmname" 
              value={souCreateDate} 
              dateFormat="dd/mm/yy"
              onChange={(e) => setSouCreateDate(e.target.value)} 
             
            />
          </div>

          <div className="col-span-1">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Update User"}</label>
<InputText className=" w-full" 
id="username" value={souUpdateUser}
onChange={(e) => setSouUpdateUser(e.target.value)}
/>
</div>

          <div className="col-span-1">
            <label className="block font-bold mb-1">Update Date</label>
            <Calendar className="w-full h-11" 
              id="firmname" 
              value={souUpdateDate} 
              dateFormat="dd/mm/yy"
              onChange={(e) => setSouUpdateDate(e.target.value)} 
             
            />
          </div>

          <div className="col-span-1">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Web Lead Id"}</label>
<InputText className=" w-full" 
id="username" value={leadId2}
onChange={(e) => setleadId2(e.target.value)}
/>
</div>

<div className="col-span-1">

<label className="block font-bold text-gray-950 justify-content-center gap-4"
htmlFor="firmname"> {"Web Lang"}</label>
<InputText className=" w-full" 
id="username" value={webLang}
onChange={(e) => setWebLang(e.target.value)}
/>
</div>
  
         
        </div>
        

      </TabPanel>
      </TabView>
      
      </div>
    
        </div>





        <Divider align="right" >
                  <div className=" align-items-center">
                   
            


     <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateCont}
      >
        {"Update & Save"}
      </button>

      <button
  className={`bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md ${leadId3 ? 'cursor-not-allowed opacity-50' : ''}`}
  onClick={handleUpdateIdSeq}
  disabled={!!leadId3}
>
  {"New & Save"}
</button>
   


             </div>
         </Divider>    

      </div>
    </div>

  </div>
        
  
        
  
  </TabPanel>

  <TabPanel
  header={
    <span
      className={`font-bold hover:border-b-2 cursor-pointer border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
        activeTab === 1
          ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300'
          : 'text-sienna-700'
      } ${saveArr < 1 ? 'text-gray-500' : 'hover:border-purple-500'}`}
    >
      {'Contact Follow Up List'}
    </span>
  }
  className="ml-5 flex"
  disabled={saveArr < 1}
>

        
        <HtlResAboutDtlEdit/>
            
   

  </TabPanel>

  <TabPanel
  header={
    <span
      className={`font-bold hover:border-b-2 cursor-pointer border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
        activeTab === 2
          ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300'
          : 'text-sienna-700'
      } ${saveArr < 1 ? 'text-gray-500' : 'hover:border-purple-500'}`}
    >
      {"Send Properties"}
    </span>
  }
  className="ml-5 flex"
  disabled={saveArr < 1}
>
          <br>
        
          </br>
          
          <CustSendPrp/>

         
      



  </TabPanel>

  
  

  

 

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 3 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Book"}
            </span>
          }
          className="ml-5 flex"
        >
          
     <CustBook/>
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 4 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Inspection Trip"}
            </span>
          }
          className="ml-5 flex"
        >
          
     <CusTrip/>
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 9 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Notes"}
            </span>
          }
          className="ml-5 flex"
        >
          
     
         

  </TabPanel>

</TabView>
  </div>
  </div>
);
};

export default CustDtlEditWeb;
